<div fxLayout="column" class="tab-sheet">
  @for (tab of tabsModel; track tab.value) {
    <div
      class="tab"
      [ngClass]="{ 'is-active': tab.selected, 'is-disabled': tab.disabled }"
      (click)="tabClick(tab.value)"
      >
      {{ tab.name }}
    </div>
  }
</div>
